import BaseIcon from './BaseIcon';
import React, { ReactElement, SVGProps } from 'react';

export default function HouseIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M14.25 19.5V15a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1-.75-.75v-8.671a.778.778 0 0 1 .244-.553l7.5-6.816a.75.75 0 0 1 1.013 0l7.5 6.816a.778.778 0 0 1 .243.553V19.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75Z"
        stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
      />
    </BaseIcon>
  );
}
